import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-ctemp',
  templateUrl: './ctemp.component.html',
  styleUrls: ['./ctemp.component.scss']
})
export class CtempComponent implements OnInit {

  exposition: CardContent = {
    title: 'c.temp|1',
    subtitle: 'Art installation and performance',
    image_source: 'assets/images/PatternBanner.png',
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Partners</h4>Orbit 3.1, Stadt Ludwigshafen',
      '<h4>Methods</h4>Reaction Diffusion Systems, Video Capture',
      '<h4>Technology / Skills</h4>WebGL, Kinect',
      '<h4>Term</h4>2013 - 2016',
      '<h4>Visit the project website</h4><a href="ctemp1.exploratory-systems.de">ctemp1.exploratory-systems.de</a>'
    ]
  };

  constructor() { }

  ngOnInit(): void {
  }

}
